export class DisclosureActionTypeConstant {
    static readonly DISCLOSURES_EMAILED: string =
        "Disclosures Emailed"
    static readonly DISCLOSURES_PRINTED: string =
        "Disclosures Printed"
}
